import {
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  Calendar,
  CalendarPlus,
  ArrowUp,
  MessageSquare,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  Circle,
  CircleAlert,
  CircleX,
  Clock,
  Copy,
  Download,
  File,
  FileText,
  GripVertical,
  Lock,
  Menu,
  Minus,
  MoreHorizontal,
  Pencil,
  Plus,
  RotateCcw,
  Search,
  Square,
  Upload,
  X,
  Paintbrush,
} from 'lucide-react';

import type {ReactNode} from 'react';

export interface IconPropsWithChildren extends React.SVGAttributes<SVGElement> {
  children?: null | undefined | ReactNode;
  color?: string;
}

export interface IconProps extends React.SVGAttributes<SVGElement> {
  children?: never;
  color?: string;
}

export type IconComponent =
  | React.ForwardRefExoticComponent<
      IconProps & React.RefAttributes<SVGSVGElement>
    >
  | React.ComponentType<IconProps>
  | React.ForwardRefExoticComponent<
      IconPropsWithChildren & React.RefAttributes<SVGSVGElement>
    >;

const DotFilled = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    width="15"
    height="15"
    fill="currentColor"
    {...props}
  >
    <circle cx="7.5" cy="7.5" r="4.5" />
  </svg>
);

const Spinner = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);

export const Icons = {
  calendar: Calendar,
  calendarPlus: CalendarPlus,
  check: Check,
  copy: Copy,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronsUpDown: ChevronsUpDown,
  clock: Clock,
  download: Download,
  fileText: FileText,
  file: File,
  x: X,
  circle: Circle,
  search: Search,
  stop: Square,
  upload: Upload,
  add: Plus,
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  menu: Menu,
  moreHorizontal: MoreHorizontal,
  pencil: Pencil,
  gripVertical: GripVertical,
  lock: Lock,
  minus: Minus,
  dotFilled: DotFilled,
  spinner: Spinner,
  circleX: CircleX,
  alert: AlertCircle,
  alertTriangle: AlertTriangle,
  error: CircleAlert,
  messageSquare: MessageSquare,
  paintbrush: Paintbrush,
  rotateCcw: RotateCcw,
};
